import { render, staticRenderFns } from "./SfNotification.vue?vue&type=template&id=57a7730f"
import script from "./SfNotification.vue?vue&type=script&lang=js"
export * from "./SfNotification.vue?vue&type=script&lang=js"
import style0 from "./SfNotification.vue?vue&type=style&index=0&id=57a7730f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports